import { Injectable } from '@angular/core';
import { BaseMapper } from '@shared/data';
import { v4 } from 'uuid';
import { LocationPublicDto, LocationsPublicSearchResultDto, PublicContractor } from '../dto';
import { LocationBookingModel, LocationsBookingModel, PublicContractorModel } from '../model';

@Injectable({
    providedIn: 'root',
})
export class LocationsBookingMapper extends BaseMapper<LocationsBookingModel, LocationsPublicSearchResultDto> {
    public mapDtoToModel(dto: LocationsPublicSearchResultDto): LocationsBookingModel {
        return {
            locations: dto.locations?.map(this.mapLocationDtoToModel.bind(this)),
        };
    }

    private mapLocationDtoToModel(dto: LocationPublicDto): LocationBookingModel {
        return {
            uuid: v4(),
            address: dto.address,
            contractors: dto.contractors?.map(this.mapContractorDtoToModel.bind(this)),
        };
    }

    private mapContractorDtoToModel(dto: PublicContractor): PublicContractorModel {
        return {
            uuid: dto.uuid,
            orgUnitUuids: dto.orgUnitUuids,
        };
    }
}
